/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Grounding_OccupationInputs */

const en_us2_plan_build_grounding_occupation = /** @type {(inputs: Plan_Build_Grounding_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work routine`)
};

const pt_br2_plan_build_grounding_occupation = /** @type {(inputs: Plan_Build_Grounding_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotina de trabalho`)
};

const es_419_plan_build_grounding_occupation = /** @type {(inputs: Plan_Build_Grounding_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rutina de trabajo`)
};

const pt_pt2_plan_build_grounding_occupation = /** @type {(inputs: Plan_Build_Grounding_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotina de trabalho`)
};

const fr_fr2_plan_build_grounding_occupation = /** @type {(inputs: Plan_Build_Grounding_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rythme de travail`)
};

const de_de2_plan_build_grounding_occupation = /** @type {(inputs: Plan_Build_Grounding_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitsalltag`)
};

const it_it2_plan_build_grounding_occupation = /** @type {(inputs: Plan_Build_Grounding_OccupationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routine di lavoro`)
};

/**
* | output |
* | --- |
* | "Work routine" |
*
* @param {Plan_Build_Grounding_OccupationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_grounding_occupation = /** @type {((inputs?: Plan_Build_Grounding_OccupationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Grounding_OccupationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_grounding_occupation(inputs)
	if (locale === "es-419") return es_419_plan_build_grounding_occupation(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_grounding_occupation(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_grounding_occupation(inputs)
	if (locale === "de-DE") return de_de2_plan_build_grounding_occupation(inputs)
	if (locale === "it-IT") return it_it2_plan_build_grounding_occupation(inputs)
	return en_us2_plan_build_grounding_occupation(inputs)
});
export { plan_build_grounding_occupation as "plan-build.grounding_occupation" }